import Api from './Api';

class LoginApi extends Api {
    async recuperarDetalhesUsuarioLogado() {
        let result = await this.fetch(this.configuracao.urlUsuario);
        return result.data;
    }

    async buscarOrgaosJulgadoresColegiados() {
        let result = await this.fetch(this.configuracao.urlOrgaosJudicantes);
        return result.data;
    }
}

export default LoginApi;
